// extracted by mini-css-extract-plugin
export default {"updateDialog":"UpdateDialog_updateDialog__6nJ3r","header":"UpdateDialog_header__DnkHO","content":"UpdateDialog_content__frHr9"};